import { Injectable } from "@angular/core";
import { LocalStorageService } from "../services/local-storage.service";
import { HttpClientService } from "./http-client.service";
import { EStorageType } from "../data-types/storage.enum";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CoworkerService {
  static instance: CoworkerService = new CoworkerService();
  constructor() {
    return (CoworkerService.instance = CoworkerService.instance || this);
  }

  public coworkingStatusModified = new Subject();
  public async getCities(filters): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/cities";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = filters;
      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkings(params): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/list";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkerBookings(id): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = `coworkers/${id}/bookings`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async changeBookingStatus(id, newState): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = `bookings/${id}/status/${newState}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = {};
      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async deleteEmployee(id): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = `coworkers/${id}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .delete(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkerInfo(id): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = `coworkers/${id}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async putCoworkerInfo(id, body): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = `coworkers/${id}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .put(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
